var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 23.75V4.25H20.4187L17.4531 1H10.5469L7.58125 4.25H1V14V23.75H27Z",
    stroke: "#FF6520",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9469 17.7149C16.8632 18.7979 15.5475 19.3393 13.9999 19.3393C12.4523 19.3393 11.1366 18.7979 10.0528 17.7149C8.96993 16.6312 8.42847 15.3155 8.42847 13.7679C8.42847 12.2203 8.96993 10.9046 10.0528 9.82085C11.1366 8.73793 12.4523 8.19647 13.9999 8.19647C15.5475 8.19647 16.8632 8.73793 17.9469 9.82085C19.0299 10.9046 19.5713 12.2203 19.5713 13.7679C19.5713 15.3155 19.0299 16.6312 17.9469 17.7149Z",
    stroke: "#FF6520",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.1a29f98cae74cb368c08dbb4597cb778.svg";
export { ForwardRef as ReactComponent };